import { ChangeEvent, useCallback } from 'react'
import { ISalesFunnelStage } from '@user/store/salesFunnel'
import { useUpdateLeadStatus } from '@user/store/lead'
import { LeadStatusSelectorProps } from './typings'
import {
  openDialogActionCreator as openDialog,
  useCWQDialogContext,
} from '@user/components/SoldServices'

export function useActions(params: LeadStatusSelectorProps) {
  const {
    salesFunnelStages,
    lead: { id, assigneeId },
  } = params

  const { execute: updateLeadStatus } = useUpdateLeadStatus()

  const [, dispatch] = useCWQDialogContext()

  const updateLeadFunnelStatus = useCallback(
    (
      stage: ISalesFunnelStage,
      reasonId: number = 0,
      customReason: string = '',
    ) =>
      void updateLeadStatus({
        leadId: id,
        salesFunnelStageId: stage.id,
        salesFunnelStageName: stage.name,
        disqualifiedDate: null,
        reasonId,
        customReason,
        owner: assigneeId,
      }),
    [assigneeId, id, updateLeadStatus],
  )

  const onChangeLeadStatus = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const stageId = Number(event.target.value)
      const stageIdx = salesFunnelStages.findIndex((x) => x.id === stageId)

      const stage = salesFunnelStages[stageIdx]

      if (stageIdx !== -1) {
        if (stage.name === 'Disqualified') {
          dispatch(openDialog('closeLose'))
        } else {
          updateLeadFunnelStatus(stage)
        }
      }
    },
    [dispatch, salesFunnelStages, updateLeadFunnelStatus],
  )

  return {
    onChangeLeadStatus,
  }
}
